import { errorHttpMessage } from "@/utils/errorDecodeUtil"
import catalogsClient from '@/axiosClients/catalogsClient'

export const getCatalogEntitlementToBenefits = async ({ commit }, params = '') => {
    try {
        const { data: result } = await catalogsClient.get(`/entitlement-to-benefits${params}`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const getNextEntitlementToBenefitKey = async ({ commit }) => {
    try {
        const { data: result } = await catalogsClient.get(`/entitlement-to-benefits/next-key`)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}

export const storeCatalogEntitlementToBenefit = async ({ commit }, payload) => {
    try {
        const { data: result } = await catalogsClient.post(`/entitlement-to-benefits/catalog`, payload)
        const { data, message, error } = result.result
        return { data, message, error }
    } catch (ex) {
        const error_http_message = errorHttpMessage(ex)
        return { message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true }
    }
}
